/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { statusWorkflowControllerCreateStatusWorkflow } from '../fn/status-workflow/status-workflow-controller-create-status-workflow';
import { StatusWorkflowControllerCreateStatusWorkflow$Params } from '../fn/status-workflow/status-workflow-controller-create-status-workflow';
import { statusWorkflowControllerDeleteStatusWorkflow } from '../fn/status-workflow/status-workflow-controller-delete-status-workflow';
import { StatusWorkflowControllerDeleteStatusWorkflow$Params } from '../fn/status-workflow/status-workflow-controller-delete-status-workflow';
import { statusWorkflowControllerGetOneStatusWorkflow } from '../fn/status-workflow/status-workflow-controller-get-one-status-workflow';
import { StatusWorkflowControllerGetOneStatusWorkflow$Params } from '../fn/status-workflow/status-workflow-controller-get-one-status-workflow';
import { statusWorkflowControllerGetStatusWorkflows } from '../fn/status-workflow/status-workflow-controller-get-status-workflows';
import { StatusWorkflowControllerGetStatusWorkflows$Params } from '../fn/status-workflow/status-workflow-controller-get-status-workflows';
import { statusWorkflowControllerUpdateStatusWorkflow } from '../fn/status-workflow/status-workflow-controller-update-status-workflow';
import { StatusWorkflowControllerUpdateStatusWorkflow$Params } from '../fn/status-workflow/status-workflow-controller-update-status-workflow';
import { StatusWorkflowItem } from '../models/status-workflow-item';
import { StatusWorkflowResponse } from '../models/status-workflow-response';

@Injectable({ providedIn: 'root' })
export class StatusWorkflowService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `statusWorkflowControllerGetStatusWorkflows()` */
  static readonly StatusWorkflowControllerGetStatusWorkflowsPath = '/status-workflow';

  /**
   * Restituisce l'elenco degli status workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statusWorkflowControllerGetStatusWorkflows()` instead.
   *
   * This method doesn't expect any request body.
   */
  statusWorkflowControllerGetStatusWorkflows$Response(params?: StatusWorkflowControllerGetStatusWorkflows$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowResponse;
}>> {
    return statusWorkflowControllerGetStatusWorkflows(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli status workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statusWorkflowControllerGetStatusWorkflows$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statusWorkflowControllerGetStatusWorkflows(params?: StatusWorkflowControllerGetStatusWorkflows$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StatusWorkflowResponse;
}> {
    return this.statusWorkflowControllerGetStatusWorkflows$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowResponse;
}>): BaseResponse & {
'data'?: StatusWorkflowResponse;
} => r.body)
    );
  }

  /** Path part for operation `statusWorkflowControllerCreateStatusWorkflow()` */
  static readonly StatusWorkflowControllerCreateStatusWorkflowPath = '/status-workflow';

  /**
   * Crea un nuovo workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statusWorkflowControllerCreateStatusWorkflow()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statusWorkflowControllerCreateStatusWorkflow$Response(params: StatusWorkflowControllerCreateStatusWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>> {
    return statusWorkflowControllerCreateStatusWorkflow(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un nuovo workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statusWorkflowControllerCreateStatusWorkflow$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statusWorkflowControllerCreateStatusWorkflow(params: StatusWorkflowControllerCreateStatusWorkflow$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StatusWorkflowItem;
}> {
    return this.statusWorkflowControllerCreateStatusWorkflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>): BaseResponse & {
'data'?: StatusWorkflowItem;
} => r.body)
    );
  }

  /** Path part for operation `statusWorkflowControllerGetOneStatusWorkflow()` */
  static readonly StatusWorkflowControllerGetOneStatusWorkflowPath = '/status-workflow/{id}';

  /**
   * Restituisce il workflow dall'id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statusWorkflowControllerGetOneStatusWorkflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  statusWorkflowControllerGetOneStatusWorkflow$Response(params: StatusWorkflowControllerGetOneStatusWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>> {
    return statusWorkflowControllerGetOneStatusWorkflow(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce il workflow dall'id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statusWorkflowControllerGetOneStatusWorkflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statusWorkflowControllerGetOneStatusWorkflow(params: StatusWorkflowControllerGetOneStatusWorkflow$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StatusWorkflowItem;
}> {
    return this.statusWorkflowControllerGetOneStatusWorkflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>): BaseResponse & {
'data'?: StatusWorkflowItem;
} => r.body)
    );
  }

  /** Path part for operation `statusWorkflowControllerDeleteStatusWorkflow()` */
  static readonly StatusWorkflowControllerDeleteStatusWorkflowPath = '/status-workflow/{id}';

  /**
   * Elimina un workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statusWorkflowControllerDeleteStatusWorkflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  statusWorkflowControllerDeleteStatusWorkflow$Response(params: StatusWorkflowControllerDeleteStatusWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>> {
    return statusWorkflowControllerDeleteStatusWorkflow(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statusWorkflowControllerDeleteStatusWorkflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  statusWorkflowControllerDeleteStatusWorkflow(params: StatusWorkflowControllerDeleteStatusWorkflow$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StatusWorkflowItem;
}> {
    return this.statusWorkflowControllerDeleteStatusWorkflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>): BaseResponse & {
'data'?: StatusWorkflowItem;
} => r.body)
    );
  }

  /** Path part for operation `statusWorkflowControllerUpdateStatusWorkflow()` */
  static readonly StatusWorkflowControllerUpdateStatusWorkflowPath = '/status-workflow/{id}';

  /**
   * Modifica un workflow.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statusWorkflowControllerUpdateStatusWorkflow()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statusWorkflowControllerUpdateStatusWorkflow$Response(params: StatusWorkflowControllerUpdateStatusWorkflow$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>> {
    return statusWorkflowControllerUpdateStatusWorkflow(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un workflow.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statusWorkflowControllerUpdateStatusWorkflow$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  statusWorkflowControllerUpdateStatusWorkflow(params: StatusWorkflowControllerUpdateStatusWorkflow$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StatusWorkflowItem;
}> {
    return this.statusWorkflowControllerUpdateStatusWorkflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StatusWorkflowItem;
}>): BaseResponse & {
'data'?: StatusWorkflowItem;
} => r.body)
    );
  }

}
